import { useQuery } from '@tanstack/react-query';
import { subActivityDam } from '../../../react_query/query-keys';
import { subActivityCountDam } from '../../../services/reactQueryservices';

const useSubActivityCountDam = (subActivity: string, startYear: string, endYear: string) => {
    const { data, isFetching, error } = useQuery({
        queryKey: [subActivityDam, subActivity, startYear, endYear],
        queryFn: () => subActivityCountDam(subActivity, startYear, endYear),
        enabled: true && !!subActivity,
        staleTime: 300
    });

    return {
        data,
        isFetching,
        error
    };
};

export default useSubActivityCountDam;
